import React from 'react'
import PropTypes from 'prop-types'
import '../DefaultButton/Button.scss'
import './CircleButton.scss'

import {colors, variants} from '../DefaultButton/Button'


export const CircleButtonSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export interface CircleButtonProps {
  infoButton?: boolean,
  variant?: string,
  color?: string,
  darkRipple?: boolean,
  disabled?: boolean,
  size?: string,
  icon: string,
  ariaLabel?: string,
  onClick?: any,
  href?: string,
  id?: string,
	className?: string,
	tabIndex?: number
}

const ClickMe = () => {
  console.log("You clicked a button!")
}


export const CircleButton = ({infoButton, variant, color, darkRipple, disabled, size, icon, ariaLabel, onClick, className, href, id, tabIndex } : CircleButtonProps) => {
  const ref = React.useRef<HTMLButtonElement>(null);
  return (
    <button
      className={
        'cc-btn cc-btn--circle' +
        ( infoButton ? ' cc-btn--info' : '') +
        ( variant ? ' cc-btn--' + variant : '' ) +
        ( color ? ' cc-btn--' + color : '' ) +
        ( darkRipple ? ' ripple--dark' : '' ) +
        ( disabled ? ' disabled' : '' ) +
        ( size ? ' cc-btn--' + size : '' ) +
        ( className ? (' ' + className) : '')
      }
      aria-label={ariaLabel}
      disabled={disabled && disabled}
      onClick={onClick && onClick}
      id={id}
			ref={ref}
			tabIndex={tabIndex ? tabIndex : 0}
    >
      <i className={'cc-btn__icon ' + icon}/>
    </button>
  )
}

CircleButton.propTypes = {
  infoButton: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(variants)),
  color: PropTypes.oneOf(Object.keys(colors)),
  darkRipple: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(CircleButtonSizes)),
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
}

CircleButton.defaultProps = {
  infoButton: false,
  variant: variants.filled,
  color: colors.accent,
  darkRipple: false,
  disabled: false,
  size: CircleButtonSizes.lg,
  ariaLabel: 'icon name',
  onClick: ClickMe,
}